<template>
  <div class="row mb-4 content-gpao">
    <div class="col-md-12 col-lg-5 col-xl-4 left-of-list pb-3">
      <div class="row">
        <div class="col-12">
          <b-pagination
            v-model="currentPage"
            pills
            :total-rows="rows"
            :per-page="perPage"
            :align="'center'"
          ></b-pagination>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="mb-1">
            <input
              v-model="value"
              type="text"
              placeholder="Recherche"
              class="form-control"
            />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <b-list-group class="of-list-scrollable">
            <b-list-group-item
              href="#"
              :active="index === 3"
              class="flex-column align-items-start"
              v-for="index in 15"
              :key="index"
            >
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">{{ 'OF-2022-00' + index }}</h5>
                <small>{{ index }} days ago</small>
              </div>
              <p class="mb-0">OF POUR LA COMMANDE DE AFRIPLAST NOUAKCHOTT</p>
            </b-list-group-item>
          </b-list-group>
        </div>
      </div>

      <!--div class="row">
            <div class="col-12">
              <vue-perfect-scrollbar :settings="{ suppressScrollX: true, wheelPropagation: false }" class="of-list-scrollable perfect-scrollbar rtl-ps-none ps scroll">
                  <b-list-group>
                      <b-list-group-item href="#" :active="index === 3" class="flex-column align-items-start" v-for="index in 15" :key="index">
                        <div class="d-flex w-100 justify-content-between">
                          <h5 class="mb-1">{{ 'OF-2022-00' + (index)}}</h5>
                          <small>{{ index }} days ago</small>
                        </div>
                        <p class="mb-0">OF POUR LA COMMANDE DE AFRIPLAST NOUAKCHOTT</p>
                      </b-list-group-item>
                  </b-list-group>
              </vue-perfect-scrollbar>
            </div>
        </div-->
    </div>
    <div class="col-md-12 col-lg-7 col-xl-8">
      <div class="row">
        <div class="col-md-12">
          <b-card class="text-black" header-class="bg-silver">
            <template v-slot:header>
              <span class="font-weight-bold"
                >Actions réalisées sans budget</span
              >
            </template>
            <p class="card-text text-black-50">asdas dasdas dasdasd</p>
          </b-card>
        </div>
      </div>
      <div class="of-content-scrollable">
        <div role="tablist">
          <b-card no-body class="mb-2" v-for="index in 35" :key="index">
            <b-card-header
              header-tag="header"
              role="tab"
              v-b-toggle="'accordion-' + (index + 1)"
              header-class="bg-silver"
            >
              <span class="when-open">
                <h6 class="m-0">
                  <a class="text-dark" href="javascript: void(0);">{{
                    'Etape ' + (index + 1)
                  }}</a>
                  <span class="accicon">
                    <a class="cursor-pointer">
                      <i :class='dashboard.ICON_REFRESH' class="font-size-17 text-success mr-4"></i
                    ></a>
                    <a class="cursor-pointer">
                      <i :class='dashboard.ICON_PLAY' class="font-size-17 text-success mr-4"></i
                    ></a>
                    <a class="cursor-pointer">
                      <i :class='dashboard.ICON_PAUSE' class="font-size-17 text-success mr-4"></i
                    ></a>
                    <a class="cursor-pointer">
                      <i :class='dashboard.ICON_STOP' class="font-size-17 text-danger mr-4"></i
                    ></a>
                    <i :class='dashboard.ICON_ANGLE_UP'></i>
                  </span>
                </h6>
              </span>
              <span class="when-closed">
                <h6 class="m-0">
                  <a class="text-dark" href="javascript: void(0);">{{
                    'Etape ' + (index + 1)
                  }}</a>
                  <span class="accicon">
                    <a class="cursor-pointer">
                      <i
                        :class='dashboard.ICON_REFRESH' class="font-size-17 text-success mr-4"
                      ></i
                    ></a>
                    <a class="cursor-pointer">
                      <i :class='dashboard.ICON_PLAY' class="font-size-17 text-success mr-4"></i
                    ></a>
                    <a class="cursor-pointer">
                      <i :class='dashboard.ICON_PAUSE' class="font-size-17 text-success mr-4"></i
                    ></a>
                    <a class="cursor-pointer">
                      <i :class='dashboard.ICON_STOP' class="font-size-17 text-danger mr-4"></i
                    ></a>
                    <i :class='dashboard.ICON_ANGLE_DOWN'></i>
                  </span>
                </h6>
              </span>
            </b-card-header>
            <b-collapse
              style="background-color: #f3f3f3"
              :id="'accordion-' + (index + 1)"
              visible
              accordion="my-accordion"
              role="tabpanel"
            >
              <p>sdasdasd asdasd</p>
            </b-collapse>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {dashboard} from '@/icons/gpao-tache/dashboard';

export default {
  name: 'Dashboard',
  data() {
    return {
      dashboard,

      title: 'Dashboard',
      rows: 100,
      perPage: 1,
      currentPage: 5,
      value: '',
      settings: {
        minScrollbarLength: 60,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.list-group-item.active,
.list-group-item.active:hover {
  border-color: #f4c334 !important;
  background-color: #ffffff;
  color: black;
}

::v-deep .pagination .page-link {
  /*background: #f4c334 ;*/
  color: #363636;
}
::v-deep .pagination .active button {
  background: #f4c334;
  border: #f4c334 1px solid;
}

/***** */
.error-tr td {
  padding: 0 0 0.5rem 0;
  margin: -10px;
  border-top: 0;
}

.card-header .accicon {
  float: right;
}
.card-header {
  cursor: pointer;
  border-bottom: 5px;
}
.card {
  border: 1px solid #ddd;
}

.bg-silver {
  background-color: transparent;
  border-color: #ced4da;
}

.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}

/**** */

.of-list-scrollable {
  position: relative;
  height: calc(100vh - 380px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.of-content-scrollable {
  position: relative;
  height: calc(100vh - 380px);
  overflow-y: auto;
  /*overflow-x: hidden;*/
  -webkit-overflow-scrolling: touch;
}

.bg-silver {
  background-color: transparent;
  border-color: #ced4da;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
